type Session = {
  accessToken: string
  refreshToken: string
}

export interface AuthApiResponse extends ApiResponse {
  data: {
    session: Session
  }
}

export interface ApiResponse {
  errorCode: number
  errorMsg: string
}

export interface ApiErrorScheme {
  response_messages: string
}

export const JOIN_TYPE = {
  SELF: 'U0200001',
  NAVER: 'U0200002',
  GOOGLE: 'U0200003',
}

export const USER_STATUS = {
  ACTIVATE: 'U0100001',
  DEACTIVATE: 'U0100002',
}
